// extracted by mini-css-extract-plugin
export var blueGhost = "MaIZ0_BIQfunQyTPi9vE cb01jVwEtfNbRseC8s53";
export var blueUnderlined = "cb01jVwEtfNbRseC8s53";
export var colourInherit = "XN7M8wbU5r15vxl2psqx";
export var focusVisible = "roCYHYXN3lN39v4QkUwF";
export var icon = "LH0Sal4X5FYpsA4TTfEy";
export var root = "fqt3O1XZTTwnDoHHzmB8";